import { render, staticRenderFns } from "./DashboardReportsAll.vue?vue&type=template&id=22772560"
import script from "./DashboardReportsAll.vue?vue&type=script&lang=js"
export * from "./DashboardReportsAll.vue?vue&type=script&lang=js"
import style0 from "./DashboardReportsAll.vue?vue&type=style&index=0&id=22772560&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports